import { render, staticRenderFns } from "./OrganisationInvoices.vue?vue&type=template&id=3b00100e&scoped=true&"
import script from "./OrganisationInvoices.vue?vue&type=script&lang=js&"
export * from "./OrganisationInvoices.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationInvoices.vue?vue&type=style&index=0&id=3b00100e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00100e",
  null
  
)

export default component.exports